import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { compose, branch, renderNothing, withPropsOnChange } from 'recompose';
import classnames from 'classnames';

import { Link } from 'components/core/Link';

import './Pagination.scss';

export const enhance = compose(
	branch((props) => !props.pages || props.pages.length < 2, renderNothing),
	withPropsOnChange(
		['selectedPage', 'pages'],
		({ selectedPage, pages }) => {
			const pageIndex = selectedPage - 1;
			return {
				prevPage: get(pages, pageIndex - 1, {}),
				nextPage: get(pages, pageIndex + 1, {})
			};
		}
	)
);

export function Pagination({
	className, pages, selectedPage, prevPage, nextPage
}) {
	return (
		<ul className={classnames('ss-pagination', className)}>
			<li className="pagination-item">
				<Link
					className={classnames('pagination-link', { disabled: selectedPage === 1 })}
					to={prevPage.url}
					rel={prevPage.nofollow ? 'nofollow' : null}
					segmentLabel={`pagination-${prevPage.number}`}
				>
					&laquo;<span className="visually-hidden">Previous page </span>
				</Link>
			</li>
			{Children.toArray(pages.map((page, index) => (
				<li className="pagination-item">
					<Link
						className={classnames('pagination-link', { active: index === selectedPage - 1 })}
						to={page.url}
						rel={page.nofollow ? 'nofollow' : null}
						segmentLabel={`pagination-${index + 1}`}
					>
						<span className="visually-hidden">Page </span>{page.number}
					</Link>
				</li>
			)))}
			<li className="pagination-item">
				<Link
					className={classnames('pagination-link', { disabled: selectedPage === pages.length })}
					to={nextPage.url}
					rel={nextPage.nofollow ? 'nofollow' : null}
					segmentLabel={`pagination-${nextPage.number}`}
				>
					<span className="visually-hidden">Next page </span>&raquo;
				</Link>
			</li>
		</ul>
	);
}

Pagination.propTypes = {
	className: PropTypes.string,
	pages: PropTypes.arrayOf(
		PropTypes.shape({
			url: PropTypes.string,
			label: PropTypes.number
		})
	).isRequired,
	prevPage: PropTypes.object.isRequired,
	nextPage: PropTypes.object.isRequired,
	selectedPage: PropTypes.number
};

export default enhance(Pagination);
